// Errores con código. El servidor traduce el código a HTTP con ESTADO_HTTP; la interfaz muestra `mensaje` tal cual
// (español de México, dirigido a la persona que usa el cotizador). Un fallo ruidoso vale más que uno silencioso:
// nunca se atrapa un ErrorCotizador para seguir como si nada.

export const CODIGOS_ERROR = [
  'NO_AUTENTICADO',
  'SIN_PERMISO',
  'NO_ENCONTRADO',
  'DATOS_INVALIDOS',
  'EDICION_INVALIDA',
  'EDICION_DESACTUALIZADA',
  'CONFLICTO',
  /** La cotización está OCUPADA: otra operación larga (la IA, el PDF) corre sobre ella, quizá desde otra pestaña u otro
   *  teléfono. No cambió nada: se espera y se vuelve a intentar (verificación adversarial de 9e40380: salía como
   *  CONFLICTO y la pantalla decía «alguien más guardó cambios»). */
  'OPERACION_EN_CURSO',
  'AVISOS_ROJOS_SIN_CONFIRMAR',
  /** El precio necesita el OK de Diego (descuento mayor al tope, margen debajo del mínimo, renglón sin monto). */
  'APROBACION_PENDIENTE',
  /** Los precios cambiaron (Diego guardó otra tabla) desde que se calculó: ya se recalculó, hay que revisar. */
  'PRECIOS_CAMBIARON',
  'IA_NO_DISPONIBLE',
  'IA_FALLO',
  'IA_TOPE_GASTO',
  'PDF_NO_DISPONIBLE',
  'PDF_FALLO',
  'CRM_EXTERNO_APAGADO',
  'ARCHIVO_NO_ACEPTADO',
  'LIMITE',
  'CONFIGURACION',
  'INTERNO',
  /** ADENDA z59 (C5): para marcarla Ganada hay que decir QUÉ opción (o nivel de baterías) se vendió: nunca se toma la recomendada
   *  en silencio. */
  'VENTA_SIN_OPCION',
  /** ADENDA z59: la aserción de la lista de compra truena (lo que suman las partidas no es el costo directo con el que se puso el
   *  precio): la hoja NO se emite. Es un error del cotizador: lo ve Diego con el detalle. */
  'LISTA_NO_CUADRA',
] as const;
export type CodigoError = (typeof CODIGOS_ERROR)[number];

export const ESTADO_HTTP: Readonly<Record<CodigoError, number>> = Object.freeze({
  NO_AUTENTICADO: 401,
  SIN_PERMISO: 403,
  NO_ENCONTRADO: 404,
  DATOS_INVALIDOS: 400,
  EDICION_INVALIDA: 400,
  EDICION_DESACTUALIZADA: 409,
  CONFLICTO: 409,
  OPERACION_EN_CURSO: 409,
  AVISOS_ROJOS_SIN_CONFIRMAR: 409,
  APROBACION_PENDIENTE: 409,
  PRECIOS_CAMBIARON: 409,
  IA_NO_DISPONIBLE: 503,
  IA_FALLO: 502,
  IA_TOPE_GASTO: 429,
  PDF_NO_DISPONIBLE: 503,
  PDF_FALLO: 422,
  CRM_EXTERNO_APAGADO: 409,
  ARCHIVO_NO_ACEPTADO: 415,
  LIMITE: 429,
  CONFIGURACION: 500,
  INTERNO: 500,
  VENTA_SIN_OPCION: 422,
  LISTA_NO_CUADRA: 500,
});

export class ErrorCotizador extends Error {
  readonly codigo: CodigoError;
  readonly detalles: string[];
  constructor(codigo: CodigoError, mensaje: string, detalles: string[] = []) {
    super(mensaje);
    this.name = 'ErrorCotizador';
    this.codigo = codigo;
    this.detalles = detalles;
  }
}

/** Forma de TODA respuesta de error de la API. */
export interface ErrorApi {
  error: { codigo: CodigoError; mensaje: string; detalles: string[] };
}

export function esErrorApi(x: unknown): x is ErrorApi {
  if (typeof x !== 'object' || x === null || !('error' in x)) return false;
  const e = (x as { error: unknown }).error;
  return typeof e === 'object' && e !== null && 'codigo' in e && 'mensaje' in e;
}

/** Afirmación que truena (para invariantes internas). */
export function afirmar(condicion: unknown, mensaje: string): asserts condicion {
  if (!condicion) throw new ErrorCotizador('INTERNO', mensaje);
}
